import { ReactElement } from "react";
import { Link } from "react-router-dom";
import WSGLearningInstituteIcon from "../../../components/Atomos/Icons/WSGLearningInstituteIcon";

interface ILayoutWithDotsProps {
  subTitle?: string | null;
  subTitleText?: string | null;
  eventLabel?: string | null; // Label like "All Events"
}

function LayoutWithDots({
  subTitle,
  subTitleText,
  eventLabel = "All Events",
}: ILayoutWithDotsProps): ReactElement {
  return (
    <>
      {subTitle ? (
        <div className="bg-primary bg-dots pt-12 pb-12 md:pt-16 md:pb-16 flex flex-row items-start justify-between px-6 md:px-12 lg:px-16">
          <div className="flex flex-col gap-3 md:gap-4 lg:gap-5 flex-1">
            {eventLabel && (
              <Link
                to="/events"
                className="flex flex-row items-center gap-2 md:gap-3 hover:underline hover:decoration-[#FFF]"
              >
                <div className="flex-shrink-0 w-4 h-4 bg-white rounded-full flex items-center justify-center">
                  <svg
                    width="4"
                    height="4"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4 text-accent-Default-dark"
                  >
                    <path
                      d="M15 18L9 12L15 6"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <span className="text-[#FFF] font-semibold text-base leading-[18px]">
                  {eventLabel}
                </span>
              </Link>
            )}

            <h2 className="text-[#FFF] text-[36px] md:text-[46px] lg:text-[52px] font-medium leading-normal md:leading-9">
              {subTitle}
            </h2>
            
            {subTitleText && (
              <p className="text-[#FFF] text-base md:text-[26px] lg:text-[32px] leading-6 md:leading-[30px] font-normal">
                {subTitleText}
              </p>
            )}
          </div>

          {/* WSG Logo in circle on the right */}
          <div className="flex-shrink-0 w-24 h-24 md:w-32 md:h-32 lg:w-40 lg:h-40 xl:w-48 xl:h-48 bg-white rounded-full flex items-center !justify-center p-2 md:p-3 lg:p-4 ml-4 md:ml-6">
            <WSGLearningInstituteIcon className="w-16 h-16 md:w-20 md:h-20 lg:w-28 lg:h-28 xl:w-36 xl:h-36 text-primary" />
          </div>
        </div>
      ) : null}
    </>
  );
}

export default LayoutWithDots;
